
import { Injectable, Renderer2, RendererFactory2, inject, DOCUMENT } from '@angular/core';
import { EstablishmentTheme } from '@pedix-workspace/utils';
import { ColorService } from './color.service';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private renderer: Renderer2;
  private document = inject(DOCUMENT);
  private colorService = inject(ColorService);

  constructor() {
    const rendererFactory = inject(RendererFactory2);

    this.renderer = rendererFactory.createRenderer(null, null);
  }

  defaultThemeColors: EstablishmentTheme = {
    color1: '#ffffff',
    colorContrast1: '#9575cd',
    color2: '#3B3C66',
    colorContrast2: '#ffffff',
    color3: '#ffd082',
    color4: '#88e1f2',
  };

  configureTheme(theme: EstablishmentTheme) {
    if (theme.color1) {
      const colorContrast1 =
        theme.colorContrast1 || this.colorService.getDefaultContrastColor1(theme.color1);

      this.renderer.setStyle(this.document.documentElement, `--theme1`, theme.color1, 2);
      this.renderer.setStyle(this.document.documentElement, `--theme1-contrast`, colorContrast1, 2);
    }
    if (theme.color2) {
      const colorContrast2 =
        theme.colorContrast2 || this.colorService.getDefaultContrastColor2(theme.color2);

      this.renderer.setStyle(this.document.documentElement, `--theme2`, theme.color2, 2);
      this.renderer.setStyle(this.document.documentElement, `--theme2-contrast`, colorContrast2, 2);
    }
    if (theme.color3) {
      this.renderer.setStyle(this.document.documentElement, `--yellow`, theme.color3, 2);
    }
    if (theme.color4) {
      this.renderer.setStyle(this.document.documentElement, `--cyan`, theme.color4, 2);
    }
  }

  resetTheme() {
    // NOTE: removeStyle doesn't work well on Safari, so we reassign color instead
    // IMPORTANT: these colors should match shared/styles/_colors.css vars
    this.configureTheme(this.defaultThemeColors);
  }
}
